import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';
import { PUBLICACOES_LINK_FIELDS } from './schema';

interface PageBrain {
  Title?: string;
  [key: string]: unknown;
}

interface LinkItem {
  title?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher o conteúdo no campo Destino, herda o título como legenda do
 * link. Só preenche quando o título está vazio (ver `Destaques/adapter.ts`).
 */
export const buildLinkFields = (
  page: PageBrain,
  item: LinkItem = {},
): Partial<LinkItem> =>
  !item.title && page.Title ? { title: page.Title } : {};

/**
 * Autofill das quatro listas de links.
 *
 * `blockAdapterBase` só sabe cuidar de UMA lista por vez (ela compara
 * `id === dictId`), então aqui o campo alterado escolhe a lista. O rótulo da
 * aba cai no gravar direto, sem o qual nada além dos links seria salvo.
 */
export const PublicacoesEditaisBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  if (PUBLICACOES_LINK_FIELDS.includes(id)) {
    blockAdapterBase(
      block,
      data,
      id,
      onChangeBlock,
      value,
      id,
      buildLinkFields,
    );
    return;
  }
  onChangeBlock(block, { ...data, [id]: value });
};

export default PublicacoesEditaisBlockDataAdapter;
